import { render, staticRenderFns } from "./TransferEmail.vue?vue&type=template&id=2e587a50"
import script from "./TransferEmail.vue?vue&type=script&lang=js"
export * from "./TransferEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports